<template>
    <vx-card class="mb-base">
        <vue-html2pdf
        :show-layout="true"
        :enable-download="true"
        :preview-modal="false"
        :paginate-elements-by-height="1400"
        filename="hee hee"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="landscape"
        pdf-content-width="1000px"
 
        @progress="onProgress($event)"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf"
    >
        <section slot="pdf-content">
            <div class="the-invoice">
            <div v-if="showButton"><vs-button type="border" color="primary" @click="generateReport">Generate</vs-button></div>
            <section class="inner_table mgt40 mgb40">
                <div class="col-2">
                    <img src="@/assets/images/logo/techViewLogo.jpg">
                </div>
                <div class="col">
                    <p class="fontSize20">
                        <strong>Techview OU 14522009</strong> <br>
                        Peterburi Tee 53 Tallinn, 11415, Estonia
                    </p>
                </div>
                <div class="col-2">
                    <p class="right invoice">
                        INVOICE
                    </p>
                    <p class="right"># <input class="w-100" :value="fieldsData.invoice_number">
                    </p>
                </div>
            </section>
            <section class="inner_table">
                <div class="col">
                    <p class="label">Client Details:</p>
                    <input class="w-full" type="" v-model="fieldsData.name">
                    <input class="w-full" type="" v-model="fieldsData.address">
                    <input class="w-full" type="" v-model="fieldsData.address2">
                </div>
                <div class="col ">
                    <p class="right">
                        Date: 
                        <input class="w-150" v-model="fieldsData.date">
                    </p>
                    
                    <p class="right">
                        Due Date: 
                        <input class="w-150"  v-model="fieldsData.dueDate">
                    </p>
                    <p class="right">
                        <strong>Balance Due:</strong>
                        <input class="w-150" type=""  v-model="fieldsData.balance">
                    </p>
                </div>
            </section>
            <section class="inner_table">
                <table class="custom-table" cellpadding="0" cellspacing="0">
                    <tr>
                        <th>
                            Item
                        </th>
                        <th width="30%">
                            Quantity
                        </th>
                        <th width="15%">
                            Rate
                        </th>
                        <th width="15%">
                            Amount
                        </th>
                    </tr>
                    <tr>
                        <td>
                            <p class="bold">Bitcoin Purchase</p>
                        </td>
                        <td>
                            <input type="" class="w-full" v-value="Number(fieldsData.amount/Rate).toFixed(2)">
                        </td>
                        <td>
                            <input type="" class="w-full" v-model="Rate">
                        </td>
                        <td>
                            <input type="" class="w-full" v-model="fieldsData.amount">
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3">
                            <p class="bold">Commission</p>
                        </td>
                        
                        <td>
                            <input type="" class="w-full" name="" value="">
                        </td>
                    </tr>
                    <tr>
                        <td colspan="4" style="padding-top:40px;"> &nbsp;</td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            
                        </td>
                        <td>
                            Subtotal:
                        </td>
                        <td>
                            <input type="" class="w-full" v-model="fieldsData.subTotal">
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <p class="bold">BTC Wallet Address: <input type="" class="w-1/2" v-model="fieldsData.wallet"></p>
                        </td>
                        <td>
                            Total:
                        </td>
                        <td>
                            <input type="" class="w-full" v-model="fieldsData.total">
                        </td>
                    </tr>
                </table>
            </section>
            <section class="inner_table">
                <p class="label">
                    Notes:
                </p>
                <textarea class="w-full fontSize18" rows="5" v-model="fieldsData.notes">
                </textarea>

                <p class="label mgt40">
                    Terms:
                </p>
                <a class="link" href="https://www.evblock.com/terms-conditions">https://www.evblock.com/terms-conditions</a>
            </section>
            </div>
           </section>
    </vue-html2pdf>
    </vx-card>
</template>

<script>
import axios from "@/axios.js"
import VueHtml2pdf from 'vue-html2pdf'
export default {
    data() {
        return {
           params:{},
           fieldsData:{},
           showButton:true
        }
    },
    components: {
       VueHtml2pdf
    },
    computed:{
        Rate:{
            get: function(){
                return this.formatNumber(this.fieldsData.rate);
            },
            set: function(str){
                this.fieldsData.rate = str;
            },
        }
    },
    mounted(){
        this.setData();
    },
    methods: {
        generateReport () {
            this.showButton = false;
            this.$refs.html2Pdf.generatePdf();
            let that = this;
            this.setTimeout(() => {
                that.showButton = true;
            }, 8000);
        },
        formatNumber: function(num) {
            if(num===undefined)
                return num;
            num = num.toString().split(',').join('');
            return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        },
        setData: function(){
            const params = new URLSearchParams();
            params.append('uname', this.$route.params.email);
            let that = this;
            axios.post("/api/invoice-maker",params)
            .then((response) => {
                let data = JSON.parse(response.data[0].object);
                console.log('data',data);
                that.fieldsData = data;
                that.fieldsData.dueDate = data.date;
            })
            .catch((error) => { console.log('error',error) })
        }
    }
}
</script>
<style lang="css" scoped>
/* RESET */
	img {
		border: none;
		-ms-interpolation-mode: bicubic;
		max-width: 100%;vertical-align: bottom;
	}

	.the-invoice {
background-color: #fff;
margin: 0;
padding: 15px;
-ms-text-size-adjust: 100%;
-webkit-text-size-adjust: 100%;
color: #2E2F30;
	}
	table {
border-collapse: separate;

	}
	/* STYLING */
	table.wrapper {
max-width: 640px;
margin: 0 auto;
padding: 24px;
	}
	a.button {
font-weight: 600;
font-size: 17px;
line-height: 24px;
letter-spacing: -0.41px;
border: 1px solid #2E2F30;
padding: 8px 16px;
border-radius: 4px;
display: inline-block;
text-align: center;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
position: relative;
		color: #2E2F30 !important;
		text-decoration: none !important;
	}
	a.button:focus, a.button:hover {border-color: #157FF3;
		color: #157FF3 !important;
	}
	a.button:active {
		top: 1px;
	}
	a.button.primary {
		background-color: #2E2F30;
		color: #fff !important;
	}
	a.button.primary:hover, a.button.primary:focus {
		background-color: #157FF3;
		color: #fff;
	}
	a.button.large {
		min-width: 192px;
		padding: 8px 16px;
		font-size: 21px;
		line-height: 26px;
		letter-spacing: 0.36px;
		text-transform: uppercase;
	}
	a.link {
		color: #000000;
		text-decoration: none;
		font-size: 18px;
	}
	a.link:hover, a.link:focus {
		color: #000000;
	}
	
	html {
		-webkit-text-size-adjust: none;
	}
	body {
		font-family: Arial, Helvetica, sans-serif;
	}
	p, .undoreset div p, .undoreset p {
		margin-top: 14px;
		margin-bottom: 14px;
	}
	.col {width: 50%; float: left; padding-left: 0px;}
	.col-2 {width: 25%; float: left; padding-left: 0px;}
	.col-3 {width: 33.33%; float: left; padding-left: 0px;}
	.col-4 {width: 33.33%; float: left; padding-left: 0px;}
	.btnLine {
		text-decoration: underline !important;
	}
	a {
		outline: none !important;
		text-decoration: none !important;
	}
	ul, ol {
		padding-left: 15px;
	}
	.inner_table {
		max-width: 1024px !important;
		margin:0px auto;
		overflow: hidden;
	}
	textarea {border:0px; font-size: 14px; font-family:Arial, Helvetica, sans-serif;}
	.custom-table {
		margin-top:40px;
		width: 100%;
		border-radius:4px 4px 0 0 ;
		-moz-border-radius:4px 4px 0 0 ;
		-webkit-border-radius:4px 4px 0 0 ;
		overflow: hidden;
		border-collapse: collapse;
		margin-bottom: 30px;
	}
	.custom-table th {background: #555252; color: #fff; height: 40px;}
	.custom-table td {padding:0 10px;}
	.centerText {
		text-align: center !important;
		margin: 0 auto;
	}
	.invoice {font-size: 50px; text-transform: uppercase;}
	.fontSize20 {
		font-size: 20px !important;
		line-height: 24px !important;
	}
	.fontSize18 {
		font-size: 18px !important;
		line-height: 22px !important;
	}
	.fontSize12 {
		font-size: 12px !important;
		line-height: 18px !important;
	}
	.fontSize14 {
		font-size: 14px !important;
		line-height: 16px !important;
	}
	.pad-r-30 {padding-right: 30px;}
	.bold {font-weight: bold;}
	.mgleft40 {margin-left: 40px;}
	.mgt40 {margin-top: 40px;}
	.mgb40 {margin-bottom: 40px;}
	.uppercase {text-transform: uppercase;}
	input {border:0px; background: #daeef2; height:30px; font-size: 20px;}
	.w-150 {width: 150px;}
	.w-100 {width: 100px;}
	.w-full {width: 100%}
	.left {
		text-align: left !important;
	}
	.right {
		text-align: right !important;
	}
	.label {
		font-size: 20px;
		font-weight: bold;
		color: #a3a0a0;
	}

	@media only screen and (max-width: 480px) {
	/* mobile-specific CSS styles go here */
	table[class="contenttable"] {
		width: 325px !important;
	}
	img[class="headerimage"] {
		width: 325px !important;
	}
	p[class="footer"] {
		font-size: 12px;
		line-height: 13px;
	}
	span[class="hide"] {
		display: none !important;
	}
	.main {
		width: 100% !important;
		min-width: 100% !important;
	}
	.res {
		width: 100% !important;
		display: block;
	}
	.inner_table {
		width: 90% !important;
	}
	
	
	*[class].full-width {
		width: 100% !important;
	}
	.full-width img {
		width: 100% !important;
		height: auto !important;
	}
	
	.center {text-align: center;}
	.hidden {
		display: none !important;
	}
	.height15 {
		height: 15px !important;
	}
	.height20 {
		height: 20px !important;
	}
	.height25 {
		height: 25px !important;
	}
	.height30 {
		height: 30px !important;
	}
	.width20 {
		width: 20px !important;
	}
	
	}
</style>